type AnalyticsValue = string | number | boolean | Date;

export type AnalyticsParams = Record<string, any> | AnalyticsValue;

export interface AbstractAdaptor {
  init?(options: any): void;

  send(event: string, params?: AnalyticsParams): void;
}

export class NullAdaptor implements AbstractAdaptor {
  send(event: string, params?: AnalyticsParams) {
    //
  }
}
